/**
 * Balões do que a Central mandou e ainda não voltou pelo monitor, no fim da
 * conversa, do lado da equipe. Estado no rodapé do balão: relógio
 * ("enviando…"), um traço ("enviado", esperando a mensagem real) ou o erro,
 * com "Tentar de novo" (e "Descartar", se nem chegou ao servidor).
 */
import React from "react";
import { FiAlertCircle, FiCheck, FiClock, FiFileText, FiMic } from "react-icons/fi";
import styled from "styled-components";

import { duracaoDoAudio, horaCurta, tamanhoLegivel, tipoDoComando } from "../apresentacao";
import { Bolha, CaixaDaMidia, LinhaDoBalao, MensagemCitada, Texto } from "../Mensagens";
import { BotaoDeTexto } from "./estilos";

const Estado = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 3px;
  font-size: 11.5px;
  line-height: 1.3;
  color: ${({ $falhou }) => ($falhou ? "var(--danger-text)" : "var(--ink-3)")};
  font-variant-numeric: tabular-nums;

  svg {
    flex: 0 0 auto;
  }
`;

const Acoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: baseline;
  gap: 4px 14px;
  max-width: min(85%, 620px);
  margin-top: 5px;
  font-size: 12.5px;
  color: var(--ink-2);
  text-align: right;
`;

const Erro = styled.span`
  color: var(--danger-text);
`;

function Anexo({ item }) {
  const tipo = tipoDoComando(item);
  if (tipo === "audio") {
    return (
      <CaixaDaMidia>
        <span aria-hidden="true"><FiMic size={18} /></span>
        <div>
          <b>Áudio gravado</b>
          {item.duracao ? <small>{duracaoDoAudio(item.duracao)}</small> : null}
        </div>
      </CaixaDaMidia>
    );
  }
  if (tipo !== "arquivo" || !item.arquivo_nome) return null;
  return (
    <CaixaDaMidia>
      <span aria-hidden="true"><FiFileText size={18} /></span>
      <div>
        <b title={item.arquivo_nome}>{item.arquivo_nome}</b>
        {item.arquivo_tamanho ? <small>{tamanhoLegivel(item.arquivo_tamanho)}</small> : null}
      </div>
    </CaixaDaMidia>
  );
}

function RotuloDoEstado({ item }) {
  const hora = horaCurta(item.criado_em);
  if (item.situacao === "falhou") {
    return (
      <Estado $falhou>
        <FiAlertCircle size={13} aria-hidden="true" /> Não foi enviada
      </Estado>
    );
  }
  if (item.situacao === "enviado") {
    return (
      <Estado title="O WhatsApp aceitou; a mensagem aparece aqui quando o monitor a ler de volta.">
        {hora} <FiCheck size={13} aria-hidden="true" /> enviada
      </Estado>
    );
  }
  return (
    <Estado role="status">
      {hora} <FiClock size={12} aria-hidden="true" /> enviando…
    </Estado>
  );
}

export default function BaloesDeEnvio({ baloes, aoTentarDeNovo, aoDescartar }) {
  if (!baloes?.length) return null;
  return baloes.map((item) => (
    <LinhaDoBalao key={item.chave} $deMim $fimDoBloco aria-label="Mensagem enviada pela Central">
      <Bolha $deMim $comPonta={false}>
        {item.citada ? <MensagemCitada mensagem={item.citada} /> : null}
        <Anexo item={item} />
        {item.texto ? <Texto>{item.texto}</Texto> : null}
        <RotuloDoEstado item={item} />
      </Bolha>
      {item.situacao === "falhou" ? (
        <Acoes>
          {item.erro ? <Erro>{item.erro}</Erro> : null}
          <BotaoDeTexto type="button" onClick={() => aoTentarDeNovo(item)}>Tentar de novo</BotaoDeTexto>
          {item.local ? (
            <BotaoDeTexto type="button" onClick={() => aoDescartar(item)}>Descartar</BotaoDeTexto>
          ) : null}
        </Acoes>
      ) : null}
    </LinhaDoBalao>
  ));
}
